import { PageLayout } from '@/components/layout/PageLayout';

/**
 * `/aboutUs` — mirrors Flutter WebAboutUsPage (presentation/web_about_us/web_about_us.dart),
 * which renders only WebPageHeader and WebPageFooter with nothing between them.
 */
export function AboutUsPage() {
  return <PageLayout>{null}</PageLayout>;
}
